import { DEV } from 'cc/env';
import { _decorator } from 'cc';
import EnhanceAnimation from '../Animation/EnhanceAnimation';
import Page from './Page';

const { ccclass, property, requireComponent } = _decorator;

@ccclass('EnhanceAnimatedPage')
@requireComponent(EnhanceAnimation)
export default class EnhanceAnimatedPage extends Page {
    @property({ tooltip: DEV && '開啟彈窗的動畫名稱' })
    private readonly openAnimationName: string = '';
    @property({ tooltip: DEV && '關閉彈窗的動畫名稱' })
    private readonly closeAnimationName: string = '';

    private _animation: EnhanceAnimation = null;

    public onLoad() {
        super.onLoad();
        this._animation = this.getComponent(EnhanceAnimation);
    }

    protected async playOpen(playTransition: boolean): Promise<void> {
        if (!this._animation) {
            return;
        }
        const promise = this._animation.waitForFinish(this.openAnimationName);
        this._animation.play(this.openAnimationName, playTransition ? 0 : Number.MAX_SAFE_INTEGER);
        if (playTransition) {
            await promise;
        }
    }

    protected async playClose(playTransition: boolean): Promise<void> {
        if (!this._animation) {
            return;
        }
        this._animation.play(this.closeAnimationName, playTransition ? 0 : Number.MAX_SAFE_INTEGER);
        if (playTransition) {
            await this._animation.waitForFinish(this.closeAnimationName);
        }
    }
}
